import { Injectable } from '@angular/core';
import { PKCEAuthorizationCodeRequestService } from './p-k-c-e-authorization-code-request.service';
import { AuthorityService } from '../../authority/authority.service';

@Injectable({
  providedIn: 'root'
})
export class PKCEAuthorizationCodeExchangeService {
  get path() {
    return this.authorizationCodeRequestService.path;
  }

  constructor(private authorizationCodeRequestService: PKCEAuthorizationCodeRequestService,
    private authorityService: AuthorityService) { }

  run(authorizationCode, verifier) {
    return this.authorityService.post(this.path, this.createBody(authorizationCode, verifier), this.createOptions());
  }

  createAuthorizationCodeRequestUrl() {
    return this.authorityService.createResourceUrl(this.path);
  }

  createOptions() {
    return this.authorizationCodeRequestService.createOptions();
  }

  createBody(code, verifier) {
    return this.authorizationCodeRequestService.createBody(code, verifier);
  }
}
